<template>
  <header>
    <el-row class="header__mobile hidden-md-and-up" type="flex" align="middle" justify="space-between">
      <!-- <router-link to="/">
        <img :src="Logo">
      </router-link> -->
      <router-link to="/products">
        購物商城
      </router-link>
      <div v-if="isLogin" style="color: white" @click="handleLogout($route.path)">
        登出
      </div>
      <router-link v-else alt="社員登入" :to="{ path: '/auth', query: { redirect: $route.path }}">
        社員登入
      </router-link>
      <Nav />
    </el-row>
    <Nav class="hidden-sm-and-down " />
    <HeaderMenu class="hidden-sm-and-down " />
  </header>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import api from '@/api'
import Logo from '@/assets/img/btn_logo.png'
import Nav from './Nav.vue'
import HeaderMenu from './HeaderMenu.vue'
export default {
  components: {
    Nav,
    HeaderMenu
  },
  data() {
    return {
      Logo
    }
  },
  computed: {
    ...mapGetters(['isLogin'])
  },
  methods: {
    ...mapActions(['clearUser']),
    async handleLogout(redirect) {
      const { account } = api
      await account.logout()
      this.clearUser()
      this.$router.push(redirect || '/')
    }
  }
}
</script>

<style scoped lang="scss">
header {
  position: relative;
}
.header__mobile {
  padding: 6px 20px;
  background-color: $deepBlue;
  a {
    line-height: 1;
    display: flex;
    color: white;
  }
  img {
    width: 48px;
    height: 48px;
  }
}

</style>
